import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=52081564&scoped=true&"
import script from "./MailList.vue?vue&type=script&lang=js&"
export * from "./MailList.vue?vue&type=script&lang=js&"
import style0 from "./MailList.vue?vue&type=style&index=0&id=52081564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52081564",
  null
  
)

export default component.exports